import GameState from './GameState';

export default class Game {
 
    constructor() {

        /**
         * @constant
         * @type {GameState}
         */
        this.gameState = new GameState();

        const selfReference = this;

        /**
         * @private
         * @type {function}
         */
        this.resourceLoadingLoop = function () {
            selfReference.waitForResourcesToLoad();
        };
    }

    /**
     * @param {Window} window 
     */
    onResize(window) {
        // Update the dimensions of the canvas to match the screen.
        this.gameState.onWindowResize(window.innerWidth, window.innerHeight);
    }

    /**
     * Invoked when the visible state of the document changes. If the page is minimized, put in a background tab,
     * or put back as the foreground tab.
     */
    onVisibilityChange() {
        if (typeof document.hidden !== "undefined") {
            console.log('Game.onVisibilityChange() hidden=' + document.hidden);
            this.gameState.onVisibilityChange(!document.hidden);
        }
    }

    /**
     * @param {Window} window
     * @param {Document} document
     */
    onLoad(window, document) {
        if (this.gameState.isStarted()) {
            return;
        }

        console.log('Game.onLoad() Loading game.');

        const thisRef = this;

        // Listen for changes in document visibility.
        document.addEventListener('visibilitychange', function (e) {
            thisRef.onVisibilityChange();
        }, false);

        this.waitForResourcesToLoad();
    }

    onUnload() {
        console.log('Game.onUnload()');
        this.gameState.saveGame();
    }

    /**
     * @private
     */
    waitForResourcesToLoad() {
        // Check to see if the sprite sheets have all been loaded.
        if (this.gameState.state.sprites.isInitialized()) {
            console.log('Game.waitForResourcesToLoad() Resources are loaded. Starting game.');
            // Start the game loop.
            this.gameState.startGame();
        }
        else {
            console.log('Game.waitForResourcesToLoad() Resources not yet loaded. Waiting...');

            // Keep waiting for the resources to load.
            window.requestAnimationFrame(this.resourceLoadingLoop);
        }
    }
}
